// WHICH BRAND AND CATEGORY NAMES A PRODUCT MAY ACTUALLY BE CLASSIFIED WITH.
//
// Extracted from NewProductModal in slice import-b, unchanged. It moved here
// because the CSV import needs the same rule in a place a `useMemo` cannot
// go: a pure per-row validator with no React around it. Restating the rule
// there instead would be a SECOND answer to "is this brand usable", and the
// first time the two disagreed the bulk path would accept a name the single
// create refuses -- silently, and in the direction that disarms a brand lock.
//
// NewProductModal still wraps these in its own useMemos, so its behaviour is
// unchanged; this file holds only the arithmetic it was already doing.

/** The names the server offers, as the create form's options.
 *
 *  ⚠️ NO LONGER INTERSECTED WITH A COMPILED LIST (configurable identity P1-9).
 *  Brands and categories are master data: what the taxonomy endpoint lists as
 *  active IS the set a product may be classified with, so a brand added in
 *  Odoo is offered without a deploy. The backend list still decides alone,
 *  which keeps the half that mattered: an archived brand is not offered.
 *
 *  Taxonomy order is PRESERVED (the endpoint sorts by name). */
export function intersectTaxonomy(
  brands: string[],
  categories: string[],
): { brandOptions: string[]; categoryOptions: string[] } {
  return { brandOptions: [...brands], categoryOptions: [...categories] };
}

/** Why nothing can be classified, naming WHICH list is empty. "" when both
 *  have entries, so a caller can render it unconditionally. */
export function emptyIntersectMessage(
  brandOptions: string[],
  categoryOptions: string[],
  _brands: string[],
  _categories: string[],
): string {
  const missing: string[] = [];
  if (brandOptions.length === 0) missing.push("brands");
  if (categoryOptions.length === 0) missing.push("categories");
  if (missing.length === 0) return "";
  return `No ${missing.join(" or ")} are currently active, so a product can't be `
       + `classified here. Add or reactivate them in Odoo.`;
}
